(() => {
  if (window.dlPremiumSizeGuideInitialized) return;

  window.dlPremiumSizeGuideInitialized = true;

  let lastFocusedElement = null;

  const findDrawer = (drawerId) => {
    return document.querySelector(
      `[data-dl-size-guide-drawer="${drawerId}"]`
    );
  };

  const findTrigger = (drawerId) => {
    return document.querySelector(
      `[data-dl-size-guide-open="${drawerId}"]`
    );
  };

  const openSizeGuide = (drawerId) => {
    const drawer = findDrawer(drawerId);

    if (!drawer) return;

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    lastFocusedElement = document.activeElement;

    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dl-size-guide-open');

    const trigger = findTrigger(drawerId);

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

    const closeButton = drawer.querySelector(
      '[data-dl-size-guide-close]'
    );

    if (closeButton) {
      window.requestAnimationFrame(() => {
        closeButton.focus();
      });
    }
  };

  const closeSizeGuide = (drawerId) => {
    const drawer = findDrawer(drawerId);

    if (!drawer) return;

    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dl-size-guide-open');

    const trigger = findTrigger(drawerId);

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (
      lastFocusedElement &&
      typeof lastFocusedElement.focus === 'function'
    ) {
      lastFocusedElement.focus();
    }
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest(
      '[data-dl-size-guide-open]'
    );

    if (openButton) {
      event.preventDefault();

      openSizeGuide(
        openButton.dataset.dlSizeGuideOpen
      );

      return;
    }

    const closeButton = event.target.closest(
      '[data-dl-size-guide-close]'
    );

    if (closeButton) {
      event.preventDefault();

      closeSizeGuide(
        closeButton.dataset.dlSizeGuideClose
      );
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const visibleDrawer = document.querySelector(
      '[data-dl-size-guide-drawer][aria-hidden="false"]'
    );

    if (visibleDrawer) {
      closeSizeGuide(
        visibleDrawer.dataset.dlSizeGuideDrawer
      );
    }
  });
})();

/* DL 2026-10-29: Byt automatiskt till en kombination som finns när kunden väljer t.ex. en färg
   som bara finns med ett visst beslag. Behåller så många av de övriga valen som möjligt
   (t.ex. längden) och föredrar varianter som går att köpa. */
(() => {
  if (window.dlVariantAutofixInitialized) return;
  window.dlVariantAutofixInitialized = true;

  const cache = new Map();

  const load = (url) => {
    if (!url || cache.has(url)) return;
    cache.set(url, null);
    fetch(url.split('?')[0] + '.js')
      .then((r) => (r.ok ? r.json() : null))
      .then((p) => { if (p && Array.isArray(p.variants)) cache.set(url, p.variants); })
      .catch(() => {});
  };

  const preload = () => {
    document.querySelectorAll('variant-selects[data-url]').forEach((el) => load(el.dataset.url));
  };

  const valueOf = (fieldset) => {
    const select = fieldset.querySelector('select');
    if (select) return select.value;
    const checked = fieldset.querySelector('input:checked');
    return checked ? checked.value : null;
  };

  const setValue = (fieldset, value) => {
    const select = fieldset.querySelector('select');
    if (select) {
      if (Array.from(select.options).some((o) => o.value === value)) select.value = value;
      return;
    }
    const input = Array.from(fieldset.querySelectorAll('input')).find((i) => i.value === value);
    if (input) input.checked = true;
  };

  document.addEventListener('change', (event) => {
    const selects = event.target.closest && event.target.closest('variant-selects');
    if (!selects) return;
    const variants = cache.get(selects.dataset.url);
    if (!variants) return;

    const fieldsets = Array.from(selects.querySelectorAll('fieldset'));
    if (fieldsets.length < 2) return;
    const changed = fieldsets.indexOf(event.target.closest('fieldset'));
    if (changed < 0) return;

    const current = fieldsets.map(valueOf);
    const exists = variants.some((v) => current.every((val, i) => v.options[i] === val));
    if (exists) return;

    let best = null;
    let bestScore = -1;
    variants.forEach((v) => {
      if (v.options[changed] !== current[changed]) return;
      let score = 0;
      current.forEach((val, i) => { if (i !== changed && v.options[i] === val) score += 10; });
      if (v.available) score += 1;
      if (score > bestScore) { best = v; bestScore = score; }
    });
    if (!best) return;

    fieldsets.forEach((fieldset, i) => {
      if (i !== changed && best.options[i] !== current[i]) setValue(fieldset, best.options[i]);
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preload);
  } else {
    preload();
  }
  document.addEventListener('shopify:section:load', preload);
})();
